"use server";

import { createAdminClient } from "@/lib/supabase/admin";

export type StudentLoginState = {
  error: string | null;
  email: string | null;
};

export async function resolveStudentLogin(
  _previousState: StudentLoginState,
  formData: FormData
): Promise<StudentLoginState> {
  const schoolCode = String(formData.get("school_code") ?? "")
    .trim()
    .toUpperCase();

  const username = String(formData.get("username") ?? "")
    .trim()
    .toLowerCase();

  if (!schoolCode || !username) {
    return {
      error: "Skolekode og brukernavn må fylles ut.",
      email: null,
    };
  }

  const admin = createAdminClient();

  const { data: school, error: schoolError } = await admin
    .from("schools")
    .select("id")
    .ilike("login_code", schoolCode)
    .eq("is_active", true)
    .maybeSingle();

  if (schoolError || !school) {
    return {
      error: "Ugyldig skolekode eller brukernavn.",
      email: null,
    };
  }

  const { data: student, error: studentError } = await admin
    .from("student_accounts")
    .select("user_id")
    .eq("school_id", school.id)
    .ilike("username", username)
    .maybeSingle();

  if (studentError || !student) {
    return {
      error: "Ugyldig skolekode eller brukernavn.",
      email: null,
    };
  }

  const { data: userData, error: userError } =
    await admin.auth.admin.getUserById(student.user_id);

  if (userError || !userData.user?.email) {
    return {
      error: "Elevkontoen kunne ikke finnes.",
      email: null,
    };
  }

  return {
    error: null,
    email: userData.user.email,
  };
}
